import SuperSearch from 'Components/SuperSearch/SuperSearch'
import PatientSuperSearch from 'NewComponents/UtilityComponents/PatientSuperSearch/PatientSuperSearch'
import React from 'react'
import AdjustmentIcon from 'SVGS/AdjustmentIcon'
import CrossIcon from 'SVGS/CrossIcon'

const PatientFilterSuperSearch = ({
    handleSelectedData,
    apiEndPoint,
    setSuperSearchPatientValue,
    superSearchPatientValue,
    handleToggle,
    filterCount,
    activeElement,
    showFilterControls = true
}) => {
    const apiUrl = apiEndPoint || `/api/Patient/PatientSuperSearch/`
    return (
        <div className="flex items-stretch w-full">
            <div className="flex-1">
                {/* <SuperSearch
                    // label={"Patient"}
                    variantType="variant2"
                    themeColor="white"
                    extraStyling={{ width: "100%" }}
                    identifier="PatientSearchForm"
                    ApiLink={`${process.env.REACT_APP_TC_PMS}${apiUrl}`}
                    method="get"
                    responseStructure={"products"}
                    placeholder={"Search Patients..."}
                    tableHeight="120"
                    tableWidth="354px"
                    getSelectedData={handleSelectedData}
                    onChange={setSuperSearchPatientValue}
                    searchValue={superSearchPatientValue}
                    tableData={[
                        { columName: "Account Num", bindingValue: "accountNum" },
                        { columName: "Name", bindingValue: "name" },
                    ]}
                    crossIcon={<CrossIcon size={16} className='text-[#8D8D8D]' />}
                /> */}
                <PatientSuperSearch
                    onChange={(value) => {
                        setSuperSearchPatientValue(value);
                    }}
                    mainSearch={true}
                    searchValue={superSearchPatientValue}
                    handleSelectedData={handleSelectedData}
                />
            </div>
            {showFilterControls && (
                <div className="bg-[#F8FAFB] p-0.5 relative border-[#EDEEEF] border border-l-0 rounded rounded-ss-none rounded-es-none flex items-center justify-center">
                    {!!filterCount && <span className="absolute top-0 z-[1] px-1 text-[8px] text-white rounded-full bg-primary">{filterCount}</span>}
                    <AdjustmentIcon onClick={() => handleToggle?.(0)} className={`block ine duration-[350ms] transform transition-all cursor-pointer ${activeElement === 0 ? "text-primary" : "text-secondaryLight"} `} />
                </div>
            )}
        </div>
    )
}

export default PatientFilterSuperSearch